const isProd = () => {
  // to prevent optimization by minification
  const isProduction = process.env.REACT_APP_DAVINCI_FRONTEND_IS_PRODUCTION;
  return isProduction && isProduction.repeat(1) === 'true';
};

export default isProd;
